import styles from "./LocalFirst.module.css";

const PRINCIPLES = [
  {
    tag: "Offline",
    title: "Offline by default",
    body: "Every app works without a network. You can spend a weekend off-grid and the desk doesn't change.",
  },
  {
    tag: "Light",
    title: "Lightweight footprint",
    body: "Tiny bundles, no telemetry, no analytics SDKs. Atlas Desk launches fast because there's almost nothing in the way.",
  },
  {
    tag: "Yours",
    title: "Files you own",
    body: "Your notes are text. Your music sits in folders you point at. No proprietary blobs. Walk away whenever you like.",
  },
];

/**
 * Local-First — frames the practical promises that make Atlas Desk
 * different from the SaaS-everything default: no accounts, no cloud,
 * tiny footprint, your data stays put. Each promise is presented as a
 * bordered "ID tag" card with an oversized mustard number and a short
 * brand stamp (Offline / Light / Yours) in the top-right, giving the
 * section a memorable, industrial personality on its dark ink canvas.
 */
export function LocalFirst() {
  return (
    <section
      id="local"
      className={styles.section}
      aria-labelledby="local-title"
    >
      <div className={`atlasContainer ${styles.inner}`}>
        <header className={styles.header}>
          <span className="atlasEyebrow">Local-First</span>
          <h2 id="local-title" className={styles.title}>
            Your tools should{" "}
            <span className={styles.titleAccent}>belong to you.</span>
          </h2>
        </header>

        <div className={styles.principles}>
          {PRINCIPLES.map((p, i) => (
            <article key={p.title} className={styles.principle}>
              <div className={styles.principleHead}>
                <span className={styles.principleNum}>0{i + 1}</span>
                <span className={styles.principleStamp}>{p.tag}</span>
              </div>
              <h3 className={styles.principleTitle}>{p.title}</h3>
              <p className={styles.principleBody}>{p.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
